import { render } from "./CaseStudyPageOne.vue?vue&type=template&id=39673900"
import script from "./CaseStudyPageOne.vue?vue&type=script&lang=js"
export * from "./CaseStudyPageOne.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\digitaldistribution.io-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__